export enum MileageValues {
    TEN_THOUSAND = 10,
    FIFTEEN_THOUSAND = 15,
    TWENTY_THOUSAND = 20,
    THIRTY_THOUSAND = 30,
    FOURTY_THOUSAND = 40,
    SIXTY_THOUSAND = 60,
    EIGHTY_THOUSAND = 80,
    UNLIMITED = 98
}
